module.exports = __webpack_public_path__ + "img/plus_price_icon1.0c766e25.png";